<template>
  <div v-if="hasPermission" id="dashboard">
    <month-metrix v-if="spanType === 'month'" @changeMonth="changeMonthHandler" @spanChange="spanChangeHandler" />
    <season-metrix v-else @changeSeason="changeMonthHandler" @spanChange="spanChangeHandler" />
    <DayIncomeTable :month="curSpanStart" :span-type="spanType" />
    <div class="row">
      <BrandStatistic :cur-month="curSpanStart" :span-type="spanType" />
      <Message />
    </div>
    <div class="row">
      <DayOrderInfo />
      <NewOrder />
    </div>
  </div>
  <div v-else class="no-permisson">
    Welcome!
  </div>
</template>
<script>
import DayOrderInfo from './partials/DayOrderInfo.vue'
import MonthMetrix from './partials/MonthMetrix.vue'
import SeasonMetrix from './partials/SeasonMetrix.vue'
import NewOrder from './partials/NewOrder.vue'
import Message from './partials/Message.vue'
import BrandStatistic from './partials/BrandStatistic.vue'
import moment from 'moment'
import DayIncomeTable from './partials/DayIncomeTable.vue'
export default {
  name: 'Dashboard',
  components: { MonthMetrix, NewOrder, DayOrderInfo, Message, BrandStatistic, DayIncomeTable, SeasonMetrix },
  data () {
    return {
      spanType: 'season',
      curSpanStart: moment().startOf('quarter').format('YYYY-MM-01')
    }
  },
  computed: {
    hasPermission () {
      return this.$store.state.privilegeLoaded && (!(this.$store.state.privileges || []).length || ~(this.$store.state.privileges || []).indexOf('m.dashboard'))
    }
  },
  methods: {
    changeMonthHandler (spanStart) {
      this.curSpanStart = moment(spanStart).format('YYYY-MM-01')
    },
    spanChangeHandler (type) {
      this.spanType = type
    }
  }
}
</script>
